<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()" class="close-modal-button">
        {{ 'm/close' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-emojis-list (emojiClicked)="onEmojiSelected($event)"></app-emojis-list>
</ion-content>
